export default __webpack_public_path__ + "static/media/oneriver_logo.e4b63f41.png";